import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { BACKEND_API_URL } from "../../../utility/api";

export const subscriptionApi = createApi({
  reducerPath: "subscriptionApi",
  baseQuery: fetchBaseQuery({
    baseUrl: BACKEND_API_URL,
    prepareHeaders: (headers) => {
      const token = localStorage.getItem("token");
      if (token) headers.set("Authorization", `Bearer ${token}`);
      return headers;
    },
  }),
  tagTypes: ["MySubscription", "PublicPlans"],
  endpoints: (builder) => ({
    getMySubscription: builder.query({
      query: () => "subscriptions/my",
      providesTags: ["MySubscription"],
    }),
    getPublicPlans: builder.query({
      query: () => "plans/public",
      providesTags: ["PublicPlans"],
    }),
    createRazorpayOrder: builder.mutation({
      query: (body) => ({
        url: "subscriptions/razorpay/order",
        method: "POST",
        body,
      }),
      invalidatesTags: ["MySubscription"],
    }),
    verifyRazorpayPayment: builder.mutation({
      query: (body) => ({
        url: "subscriptions/razorpay/verify",
        method: "POST",
        body,
      }),
      invalidatesTags: ["MySubscription"],
    }),
  }),
});

export const {
  useGetMySubscriptionQuery,
  useGetPublicPlansQuery,
  useCreateRazorpayOrderMutation,
  useVerifyRazorpayPaymentMutation,
} = subscriptionApi;
